import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal, Textarea, TextInput, Tabs, Accordion } from "flowbite-react"
import Select from 'react-tailwindcss-select';
import { HiOutlineTrash, HiOutlineDocumentAdd, HiOutlineMinus, HiOutlinePlus } from "react-icons/hi";
import { FaRegEdit } from "react-icons/fa";
import { getAllRegion, getAllSubRegion } from '../../redux/locationReducer';
import { modifyProduct, getProductsByFilter } from '../../redux/productReducer';
import { openSnackBar } from '../../redux/snackBarReducer';
import UploadImage from '../Global/UploadImage';
import MultiData from '../Global/MultiData';
import MultiRange from "../Global/MultiRange";
import { createProductSearchText } from '../../utils'
import swal from 'sweetalert2';
import styled from 'styled-components';
import { useTranslation } from "react-i18next";
// p.truncate{
//     width: 65px;
// }
// div.relative.w-full{
// 	width: 142px;
// }	
export const SelectGrapeStyle = styled.div`
.flex.text-sm.text-gray-500.border.border-gray-300.rounded.shadow-sm.transition.duration-300{
	height: 42px
}
`
export const SelectCustomStyle = styled.div`
.flex.text-sm.text-gray-500.border.border-gray-300.rounded.shadow-sm.transition.duration-300{
	height: 42px
}
`

function CreateProduct(props) {
    const { t } = useTranslation();
    const { globalState, locationState } = useSelector((state) => state);
    const { categories, winecolors, bottlesizes, countries, regions, subregions, grapes, aromas, foods, allergies, closureTypes, official_classifications, special_classifications, destillations, palates, vessels, soils, glasswares, bottle_shapes } = locationState;
    const nowDate = new Date();

    const dispatch = useDispatch();

    useEffect(() => {
    }, [])

    /////////select/////////////////
    const country_options = [];
    const region_options = [];
    const subregion_options = [];
    const category_options = [];
    const winecolor_options = [];
    const winetype_options = [];
    const fortified_options = [];
    const spirittype_options = [];
    const beertype_options = [];
    const vintage_options = [];
    const bottlesize_options = [];
    const grape_options = [];
    const aroma_options = [];
    const food_options = [];
    const allergy_options = [];
    const closureType_options = [];

    const destillation_options = [];
    const palate_options = [];
    const vessel_options = [];
    const soil_options = [];
    const glassware_options = [];
    const bottle_shape_options = [];

    // for residual sugar taste
    var tmp_taste = []; 

    // country
    if (countries?.length > 0) {
        countries.map((data, index) => {
            country_options[index] = { value: data._id, label: data.name[`${globalState.language}`] }
        })
    }
    // region
    if (regions?.length > 0) {
        regions.map((data, index) => {
            region_options[index] = { value: data._id, label: data.name[`${globalState.language}`] }
        })
    }
    // subregion
    if (subregions?.length > 0) {
        subregions.map((data, index) => {
            subregion_options[index] = { value: data._id, label: data.name[`${globalState.language}`] }
        })
    }
    // category & winetype & fortified
    if (categories?.length > 0) {
        categories.map((data, index) => {
            category_options[index] = { value: data._id, label: data[`${globalState.language}`] };
            if (data._id === 0) { //wine
                data.sub.map((wine_type, i) => {
                    winetype_options[i] = { value: wine_type.index, label: wine_type[`${globalState.language}`] };
                    if (wine_type.sub.length > 0) {
                        wine_type.sub.map((forti, inc) => {
                            fortified_options[inc] = { value: inc, label: forti };
                        })
                    }
                })
            }
            if (data._id === 1) { //spirit
                data.sub.map((spirit, i) => {
                    spirittype_options[i] = { value: i, label: spirit[`${globalState.language}`] };
                })
            }
            if (data._id === 2) { //beer
                data.sub.map((beer, i) => {
                    beertype_options[i] = { value: i, label: beer[`${globalState.language}`] };
                })
            }
        })
    }
    //winecolor
    if (winecolors?.length > 0) {
        winecolors.map((data, index) => {
            winecolor_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }
    //vintage
    vintage_options[0] = { value: 0, label: "N/A" };
    for (let i = nowDate.getFullYear() + 1; i >= 1900; i--) {
        vintage_options[nowDate.getFullYear() + 2 - i] = { value: i, label: i.toString() };
    }
    //bottlesize
    if (bottlesizes?.length > 0) {
        bottlesizes.map((data, index) => {
            bottlesize_options[index] = { value: data._id, label: data.bottle_size + data.unit }
        })
    }
    //grape
    if (grapes?.length > 0) {
        grapes.map((data, index) => {
            grape_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }
    //aroma
    if (aromas?.length > 0) {
        aromas.map((data, index) => {
            aroma_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }
    //food
    if (foods?.length > 0) {
        foods.map((data, index) => {
            food_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }
    //allergy
    if (allergies?.length > 0) {
        allergies.map((data, index) => {
            allergy_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }
    //allergy
    if (closureTypes?.length > 0) {
        closureTypes.map((data, index) => {
            closureType_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }

    // destillation
    if (destillations?.length > 0) {
        destillations.map((data, index) => {
            destillation_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }

    // palate
    if (palates?.length > 0) {
        palates.map((data, index) => {
            palate_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }    
    
    // vessel
    if (vessels?.length > 0) {
        vessels.map((data, index) => {
            vessel_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }

    // soil
    if (soils?.length > 0) {
        soils.map((data, index) => {
            soil_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }

    // glassware
    if (glasswares?.length > 0) {
        glasswares.map((data, index) => {
            glassware_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }

    // bottle_shape
    if (bottle_shapes?.length > 0) {
        bottle_shapes.map((data, index) => {
            bottle_shape_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }

    const [modalShow, setModalShow] = useState(false);
    const [overStyle, setOverStyle] = useState(false);
    // const [producer, setProducer] = useState(props?.producer);
    const [product, setProduct] = useState(props?.product);
    const [showSubSpirit, setShowSubSpirit] = useState(false);
    const [showRegionSelect, setShowRegionSelect] = useState(false);
    const [showSubRegionSelect, setShowSubRegionSelect] = useState(false);
    const [spiritsubtype_options, setSpiritSubTypeOptions] = useState([]);
    // const [productType, setProductType] = useState("");
    const [bottleImage, setBottleImages] = useState(null);
    const [showBottleImage, setShowBottleImages] = useState(null);
    const [grape, setGrape] = useState("");
    const [percentage, setPercentage] = useState("");
    const [taste_options, setTasteOption] = useState([]);
    const [currentLengthOfDescription, setCurrentLengthOfDescription] = useState(0);
    const [currentLengthOfDescriptionTeaser, setCurrentLengthOfDescriptionTeaser] = useState(0);
    const [currentLengthOfDescriptionShort, setCurrentLengthOfDescriptionShort] = useState(0);
    const [official_classification_options, setOfficialClassificationOption] = useState([]);
    const [special_classification_options, setSpecialClassificationOption] = useState([]);

    const [productData, setProductData] = useState({
        product_name: "",
        producer_name: "",
        product_type: "",
        // for wine
        wine_color: "",
        wine_type: "",
        fortified_wine_type: "",
        variaty: [],
        barrel_type: "",
        wine_acid: "",
        // for spirit
        spirit_sub_type: "",
        spirit_type: "",
        //for beer
        beer_type: "",
        // for wine & spirit
        vintage: "",
        taste: "",
        //for all
        bottle_size: "",
        article: "",
        // for basic
        country: "",
        region: "",
        sub_region: "",
        description: "",
        description_teaser: "",
        description_short: "",
        // for advanced
        alc_vol: "",
        aroma: [],
        food: [],
        allergy: [],
        added_aroma: "",
        added_food: "",
        added_allergy: "",
        closure_type: "",
        residual_sugar: "",

        //new added
        ean: "",
        official_classification: "",
        special_classification: "",
        destillation: "",
        aromataste: [],
        palate: [],
        vessel: [],
        soil: [],
        added_aromataste: "",
        added_palate: "",
        added_vessel: "",
        added_soil: "",
        acidity: "",
        glassware: "",
        bottle_shape: "",
        recomended_drinking_temperature: [-3, 23]
    });
    const [changeState, setChangeState] = useState({
        product_name: "unchange",
        producer_name: "unchange",
        product_type: "unchange",
        // for wine
        wine_color: "unchange",
        wine_type: "unchange",
        fortified_wine_type: "unchange",
        variaty: "unchange",
        barrel_type: "unchange",
        wine_acid: "unchange",
        // for spirit
        spirit_sub_type: "unchange",
        spirit_type: "unchange",
        //for beer
        beer_type: "unchange",
        // for wine & spirit
        vintage: "unchange",
        taste: "unchange",
        //for all
        bottle_size: "unchange",
        bottle_image: "unchange",
        article: "change",
        // for basic
        country: "unchange",
        region: "unchange",
        sub_region: "unchange",
        description: "unchange",
        description_teaser: "unchange",
        description_short: "unchange",
        // for advanced
        alc_vol: "unchange",
        aroma: "unchange",
        food: "unchange",
        allergy: "unchange",
        closure_type: "unchange",
        residual_sugar: "unchange",

        //new added
        ean: "unchange",
        official_classification: "unchange",
        special_classification: "unchange",
        destillation: "unchange",
        aromataste: "unchange",
        palate: "unchange",
        vessel: "unchange",
        soil: "unchange",
        acidity: "unchange",
        glassware: "unchange",
        bottle_shape: "unchange",
        recomended_drinking_temperature: "unchange"
    })

    const selectCountry = (value) => {
        if (value.value >= 0) {
            dispatch(getAllRegion(value.value));
            setShowRegionSelect(true);

            setShowSubRegionSelect(false)
            productData.region = "";
            productData.sub_region = "";
            setProductData({ ...productData });

            // official_classification
            let official_cnt = 0;
            if (official_classifications?.length > 0) {
                official_classifications.map((data, index) => {
                    if(data.country == value.value){
                        official_classification_options[official_cnt] = { value: data._id, label: data[`${globalState.language}`] + " (" + data.shortcut + ")" }
                        official_cnt++;
                    }
                    setOfficialClassificationOption([...official_classification_options]);
                })
            }

            // special_classification
            let special_cnt = 0;
            if (special_classifications?.length > 0) {
                special_classifications.map((data, index) => {
                    if(data.country == value.value){
                        special_classification_options[special_cnt] = { value: data._id, label: data[`${globalState.language}`]}
                        special_cnt++;
                    }
                    setSpecialClassificationOption([...special_classification_options]);
                })
            }
        }
    };

    const selectRegion = (value) => {
        if (value.value >= 0) {
            dispatch(getAllSubRegion(productData.country.value, value.value));
            setShowSubRegionSelect(true)

            productData.sub_region = "";
            setProductData({ ...productData });
        }
    };

    const selectSpiritType = (value) => {
        productData.spirit_type = value;
        setProductData({ ...productData });

        setShowSubSpirit(categories[1].sub[value.value]?.is_sub);
        // subregion
        if (categories[1].sub[value.value].sub?.length > 0) {
            categories[1].sub[value.value].sub.map((data, index) => {
                spiritsubtype_options[index] = { value: index, label: data }
            })
            setSpiritSubTypeOptions([...spiritsubtype_options]);
        }
    }

    //begin for variaty
    const removeGrapeVariaty = () => {
        setGrape("");
        setPercentage("");
    }

    const addGrapeVariaty = () => {
        var flag = false;
        if (grape) {
            const { variaty } = productData;
            variaty.map((data, i) => {
                if (data.grape.value === grape.value) {
                    flag = true;
                    setGrape("");
                    dispatch(openSnackBar({ status: "error", message: `${t("msg_already_exist")} ${grape.label.toLowerCase()} ${t("msg_in_grape_variety")}` }));
                }
            })

            if (!flag) {
                productData.variaty = [...productData.variaty, { grape: grape, percentage: percentage }];
                setProductData({ ...productData });

                //for company product change state
                changeState['variaty'] = "change";
                setChangeState({ ...changeState });

                setGrape("");
                setPercentage("");
            }

        } else {
            dispatch(openSnackBar({ status: "error", message: t("msg_select_grape_name") }));
        }
    }

    const setExistVariate = (type, index, value) => {
        const { variaty } = productData;
        var flag = false;
        if (type === "remove") {
            variaty.splice(index, 1);

            //for company product change state
            changeState['variaty'] = "change";
            setChangeState({ ...changeState });
        } else {
            if (type === "grape") {
                let tmpVairaty = [...variaty, {grape: grape}];
                tmpVairaty.map((data, i) => {
                    if (data.grape.value === value.value) {
                        flag = true;
                        // setGrape("");
                        dispatch(openSnackBar({ status: "error", message: `${t("msg_already_exist")} ${value.label.toLowerCase()} ${t("msg_in_grape_variety")}` }));
                    }
                })
                if (!flag) {
                    variaty[index][`${type}`] = value;

                    //for company product change state
                    changeState['variaty'] = "change";
                    setChangeState({ ...changeState });
                }
            } else {
                variaty[index][`${type}`] = value;

                //for company product change state
                changeState['variaty'] = "change";
                setChangeState({ ...changeState });
            }
        }

        productData.variaty = variaty;
        setProductData({ ...productData });
    }

    const setAddVariate = (type, value) => {
        // const { variaty } = productData;
        let flag = false;
        if (type === "grape") {
            variaty.map((data, i) => {
                if (data.grape.value === value.value) {
                    flag = true;
                    // setGrape("");
                    dispatch(openSnackBar({ status: "error", message: `${t("msg_already_exist")} ${value.label.toLowerCase()} ${t("msg_in_grape_variety")}` }));
                }
            })
            if (!flag) {
                setGrape(value);

                //for company product change state
                changeState['variaty'] = "change";
                setChangeState({ ...changeState });
                // variaty[variaty.length][`${type}`] = value;
            }
        } else {
            setPercentage(value)

            //for company product change state
            changeState['variaty'] = "change";
            setChangeState({ ...changeState });
            // variaty[variaty.length][`${type}`] = value;
        }
    }
    //end for variaty

    //begin for template
    const addMultiData = (title, value) => {
        let item = title.toLowerCase();
        productData[`${item}`] = [...productData[`${item}`], value];
        productData[`added_${item}`] = ""
        setProductData({ ...productData });

        //for company product change state
        changeState[`${item}`] = "change";
        setChangeState({ ...changeState });

    }

    const setExistData = (title, type, value, index) => {
        let item = title.toLowerCase();
        var flag = false;

        if (type === "remove") {
            productData[`${item}`].splice(value, 1);

            //for company product change state
            changeState[`${item}`] = "change";
            setChangeState({ ...changeState });
        } else if (type === "change") {
            let tmpData = [...productData[`${item}`], productData[`added_${item}`]];
            tmpData.map((data, i) => {
                if (data.value === value.value) {
                    flag = true;
                    // setGrape("");
                    dispatch(openSnackBar({ status: "error", message: `${t("msg_already_exist")} ${value.label.toLowerCase()} in ${title.toLowerCase()}` }));
                }
            })
            if (!flag) {
                productData[`${item}`][index] = value;

                //for company product change state
                changeState[`${item}`] = "change";
                setChangeState({ ...changeState });
            }
        }

        setProductData({ ...productData });
    }

    const setChangedData = (title, value) => {
        let item = title.toLowerCase();
        var flag = false;

        productData[`${item}`].map((data, i) => {
            if (data.value === value.value) {
                flag = true;
                // setGrape("");
                dispatch(openSnackBar({ status: "error", message: `${t("msg_already_exist")} ${value.label.toLowerCase()} in ${title.toLowerCase()}` }));
            }
        })
        if (!flag) {
            productData[`added_${item}`] = value; 

            //for company product change state
            changeState[`${item}`] = "change";
            setChangeState({ ...changeState });
        }
        return flag;
    }
    //end for template

    // we need to init the filled data
    // const clickProductType = (value) => {
    //     // setProductData({
    //     //     // product_name: "",
    //     //     // for wine
    //     //     // wine_color: "",
    //     //     wine_type: "",
    //     //     fortified_wine_type: "",
    //     //     variaty: [],
    //     //     barrel_type: "",
    //     //     wine_acid: "",
    //     //     // for spirit
    //     //     spirit_sub_type: "",
    //     //     spirit_type: "",
    //     //     //for beer
    //     //     beer_type: "",
    //     //     // for wine & spirit
    //     //     vintage: "",
    //     //     //for all
    //     //     bottle_size: "",
    //     //     article: "",
    //     //     // for basic
    //     //     country: "",
    //     //     region: "",
    //     //     sub_region: "",
    //     //     description: "",
    //     //     // for advanced
    //     //     alc_vol: "",
    //     //     aroma: [],
    //     //     food: [],
    //     //     allergy: [],
    //     //     closure_type: "",
    //     //     residual_sugar: ""
    //     // });

    //     productData.product_type = value;
    //     setProductData({ ...productData });

    //     setShowRegionSelect(false);
    //     setShowSubRegionSelect(false);
    //     setBottleImages(null);
    //     setShowBottleImages(null);
    //     // setProductType(value)
    //     setCurrentLengthOfDescription(0);
    // }

    const selectWineType = (value) => {
        handleInputChange("wine_type", value)
        tmp_taste = [];
        categories[0].sub[value.value - 1].taste.map((data, index) => {
            tmp_taste[index] = { value: index, label: data }
        })
        setTasteOption(tmp_taste);
    }

    function validate() {
        if (productData.product_type.value === 0) {// wine
            const { product_name, wine_color, wine_type, bottle_size, country, region, description, description_short, description_teaser } = productData;
            if (!product_name) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_fill_product_name") }))
                return false;
            } else if (!wine_color) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_wine_color") }))
                return false;
            } else if (!wine_type) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_wine_type") }))
                return false;
            } else if (!bottle_size) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_bottle_size") }))
                return false;
            } else if (!country) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_country") }))
                return false;
            } else if (!region) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_region") }))
                return false;
            } else if (description.length > 500) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_description_length") }))
                return false;
            } else if (description_teaser.length > 100) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_description_teaser_length") }))
                return false;
            } else if (description_short.length > 250) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_description_short_length") }))
                return false;
            }
            return true;
        } else if (productData.product_type.value === 1) { // spirit
            const { product_name, spirit_type, bottle_size, country, region, description, description_short, description_teaser } = productData;
            if (!product_name) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_fill_product_name") }))
                return false;
            } else if (!spirit_type) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_spirit_type") }))
                return false;
            } else if (!bottle_size) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_bottle_size") }))
                return false;
            } else if (!country) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_country") }))
                return false;
            } else if (!region) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_region") }))
                return false;
            } else if (description.length > 500) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_description_length") }))
                return false;
            } else if (description_teaser.length > 100) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_description_teaser_length") }))
                return false;
            } else if (description_short.length > 250) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_description_short_length") }))
                return false;
            }
            return true;
        } else if (productData.product_type.value === 2) { // beer
            const { product_name, beer_type, bottle_size, country, region, description, description_short, description_teaser } = productData;
            if (!product_name) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_fill_product_name") }))
                return false;
            } else if (!beer_type) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_beer_type") }))
                return false;
            } else if (!bottle_size) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_bottle_size") }))
                return false;
            } else if (!country) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_country") }))
                return false;
            } else if (!region) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_select_region") }))
                return false;
            } else if (description.length > 500) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_description_length") }))
                return false;
            } else if (description_teaser.length > 100) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_description_teaser_length") }))
                return false;
            } else if (description_short.length > 250) {
                dispatch(openSnackBar({ status: "warning", message: t("msg_description_short_length") }))
                return false;
            }
            return true;
        } else if (productData.product_type.value === 3) {  // other

        }
    }

    const saveProduct = async () => {
        var validate_result = validate();

        if (validate_result) {
            const formData = new FormData();

            const { producer_name, product_name, product_type, vintage, bottle_size, article, country, region, sub_region, spirit_type, spirit_sub_type, beer_type,
                variaty, description, description_short, description_teaser, alc_vol, aroma, food, barrel_type, taste, residual_sugar, wine_acid, wine_color, wine_type, fortified_wine_type,
                closure_type, allergy, added_allergy, added_aroma, added_food, ean, official_classification, special_classification, destillation, aromataste,
                palate, vessel, soil, added_aromataste, added_palate, added_soil, added_vessel, acidity, glassware, bottle_shape, recomended_drinking_temperature  } = productData;
            // const { producer } = props;

            var searchText = createProductSearchText(productData, { name: producer_name }, product_type);

            var grape_variaty = [];
            if (variaty?.length > 0) {
                variaty.map((data, index) => {
                    grape_variaty[index] = { grape: data.grape.value, percentage: data?.percentage };
                })
            }
            if(grape){
                grape_variaty = [...grape_variaty, {grape: grape.value, percentage: percentage}]
            }

            var aroma_send = [];
            if (aroma.length > 0) {
                aroma.map((data, index) => {
                    aroma_send[index] = data.value;
                })
            }
            if(added_aroma){
                aroma_send = [...aroma_send, added_aroma.value]
            }

            var food_send = [];
            if (food.length > 0) {
                food.map((data, index) => {
                    food_send[index] = data.value;
                })
            }
            if(added_food){
                food_send = [...food_send, added_food.value]
            }

            var allergy_send = [];
            if (allergy.length > 0) {
                allergy.map((data, index) => {
                    allergy_send[index] = data.value;
                })
            }
            if(added_allergy){
                allergy_send = [...allergy_send, added_allergy.value]
            }

            var aromataste_send = [];
            if (aromataste.length > 0) {
                aromataste.map((data, index) => {
                    aromataste_send[index] = data.value;
                })
            }
            if(added_aromataste){
                aromataste_send = [...aromataste_send, added_aromataste.value]
            }

            var palate_send = [];
            if (palate.length > 0) {
                palate.map((data, index) => {
                    palate_send[index] = data.value;
                })
            }
            if(added_palate){
                palate_send = [...palate_send, added_palate.value]
            }

            var vessel_send = [];
            if (vessel.length > 0) {
                vessel.map((data, index) => {
                    vessel_send[index] = data.value;
                })
            }
            if(added_vessel){
                vessel_send = [...vessel_send, added_vessel.value]
            }

            var soil_send = [];
            if (soil.length > 0) {
                soil.map((data, index) => {
                    soil_send[index] = data.value;
                })
            }
            if(added_soil){
                soil_send = [...soil_send, added_soil.value]
            }

            // const { role } = userInfo;
            formData.append("modified_by", props.condition.user_id);
            formData.append("role", props.condition.role);
            formData.append("company", props.condition.company);
            formData.append("isGlobal", props.condition.isGlobal);
            formData.append("user_id", props.condition.user_id);
            formData.append("change_state", JSON.stringify(changeState));
            // formData.append("producer_name", producer_name);
            if (product_type.value === 0) { //wine
                formData.append("product_name", product_name);
                
                formData.append("product_type", product_type.value);
                formData.append("wine_color", wine_color.value);
                formData.append("wine_type", wine_type.value);
                fortified_wine_type && formData.append("fortified_wine_type", fortified_wine_type.value);

                vintage && formData.append("vintage", vintage.value);
                formData.append("bottle_size", bottle_size.value);
                article && formData.append("article", article);
                // basic
                country && formData.append("country", country.value);
                region && formData.append("region", region.value);
                sub_region && formData.append("sub_region", sub_region.value);
                variaty && formData.append("variaty", JSON.stringify(grape_variaty));
                description && formData.append("description", description);
                description_teaser && formData.append("description_teaser", description_teaser);
                description_short && formData.append("description_short", description_short);
                bottleImage && formData.append("bottleImage", bottleImage);
                // advanced
                alc_vol && formData.append("alc_vol", alc_vol);
                aroma && formData.append("aroma", JSON.stringify(aroma_send));
                food && formData.append("food", JSON.stringify(food_send));
                barrel_type && formData.append("barrel_type", barrel_type);
                residual_sugar && formData.append("residual_sugar", residual_sugar);
                taste && formData.append("taste", taste.value);
                wine_acid && formData.append("wine_acid", wine_acid);
                closure_type && formData.append("closure_type", closure_type.value);
                allergy && formData.append("allergy", JSON.stringify(allergy_send));
                searchText && formData.append("search_field", searchText);

                //new added
                ean && formData.append("ean", ean);
                official_classification && formData.append("official_classification", official_classification.value);
                special_classification && formData.append("special_classification", special_classification.value);
                aromataste && formData.append("aromataste", JSON.stringify(aromataste_send));
                palate && formData.append("palate", JSON.stringify(palate_send));
                vessel && formData.append("vessel", JSON.stringify(vessel_send));
                soil && formData.append("soil", JSON.stringify(soil_send));
                acidity && formData.append("acidity", acidity);
                glassware && formData.append("glassware", glassware.value);
                bottle_shape && formData.append("bottle_shape", bottle_shape.value);
                recomended_drinking_temperature && formData.append("recomended_drinking_temperature", JSON.stringify(recomended_drinking_temperature));
            } else if (product_type.value === 1) { // spirit
                formData.append("product_name", product_name);

                formData.append("product_type", product_type.value);
                formData.append("spirit_type", spirit_type.value);
                spirit_sub_type && formData.append("spirit_sub_type", spirit_sub_type.value);

                vintage && formData.append("vintage", vintage.value);
                formData.append("bottle_size", bottle_size.value);
                article && formData.append("article", article);
                // basic
                country && formData.append("country", country.value);
                region && formData.append("region", region.value);
                sub_region && formData.append("sub_region", sub_region.value);
                description && formData.append("description", description);
                description_teaser && formData.append("description_teaser", description_teaser);
                description_short && formData.append("description_short", description_short);
                bottleImage && formData.append("bottleImage", bottleImage);
                // advanced
                alc_vol && formData.append("alc_vol", alc_vol);
                aroma && formData.append("aroma", JSON.stringify(aroma_send));
                food && formData.append("food", JSON.stringify(food_send));
                barrel_type && formData.append("barrel_type", barrel_type);
                residual_sugar && formData.append("residual_sugar", residual_sugar);
                wine_acid && formData.append("wine_acid", wine_acid);
                closure_type && formData.append("closure_type", closure_type.value);
                allergy && formData.append("allergy", JSON.stringify(allergy_send));
                searchText && formData.append("search_field", searchText);

                //new added
                ean && formData.append("ean", ean);
                destillation && formData.append("destillation", destillation.value);
                aromataste && formData.append("aromataste", JSON.stringify(aromataste_send));
                vessel && formData.append("vessel", JSON.stringify(vessel_send));
                acidity && formData.append("acidity", acidity);
                glassware && formData.append("glassware", glassware.value);
                recomended_drinking_temperature && formData.append("recomended_drinking_temperature", JSON.stringify(recomended_drinking_temperature));
            } else if (product_type.value === 2) { // beer
                formData.append("product_name", product_name);

                formData.append("product_type", product_type.value);
                formData.append("beer_type", beer_type.value);

                formData.append("bottle_size", bottle_size.value);
                article && formData.append("article", article);
                // basic
                country && formData.append("country", country.value);
                region && formData.append("region", region.value);
                sub_region && formData.append("sub_region", sub_region.value);
                description && formData.append("description", description);
                description_teaser && formData.append("description_teaser", description_teaser);
                description_short && formData.append("description_short", description_short);
                bottleImage && formData.append("bottleImage", bottleImage);
                // advanced
                alc_vol && formData.append("alc_vol", alc_vol);
                aroma && formData.append("aroma", JSON.stringify(aroma_send));
                food && formData.append("food", JSON.stringify(food_send));
                residual_sugar && formData.append("residual_sugar", residual_sugar);
                closure_type && formData.append("closure_type", closure_type.value);
                allergy && formData.append("allergy", JSON.stringify(allergy_send));
                searchText && formData.append("search_field", searchText);

                //new added
                ean && formData.append("ean", ean);
                aromataste && formData.append("aromataste", JSON.stringify(aromataste_send));
                vessel && formData.append("vessel", JSON.stringify(vessel_send));
                acidity && formData.append("acidity", acidity);
                glassware && formData.append("glassware", glassware.value);
                recomended_drinking_temperature && formData.append("recomended_drinking_temperature", JSON.stringify(recomended_drinking_temperature));
            } else if (productData.product_type.value === 3) {   // other

            }


            const res = await dispatch(modifyProduct(props.product._id, formData));
            if (res !== false) {
                dispatch(openSnackBar({ message: t("msg_success_modify_product"), status: 'success' }));
                await dispatch(getProductsByFilter(props.condition));
                close();
                return res;
            } else {
                return false;
            }

        }

    }

    const handleInputChange = (key, value) => {
        productData[`${key}`] = value;
        changeState[`${key}`] = "change";

        setProductData({ ...productData });
        setChangeState({ ...changeState });
    };

    const openModal = () => {
        const { product } = props;
        // setProducer(producer);
        if (product) {
            setProduct(product);
            const { producer, product_name, wine_color, product_type, vintage, category, sub_category, article_nr, grape_variety, bottle_image,
                country, region, sub_region, bottle_size, description_text, description_teaser_text, description_short_text, alc_vol, aroma, food_pairing, barrel_type, taste, residual_sugar, wine_acid,
                closure_type, allergy, ean, official_classification, special_classification, aroma_taste, palate, vessel, soil_type, acidity, glassware, bottle_shape, distillation, recomended_drinking_temperature  } = product;
            
            setCurrentLengthOfDescription(description_text ? description_text.length : 0)
            setCurrentLengthOfDescriptionTeaser(description_teaser_text ? description_teaser_text.length : 0)
            setCurrentLengthOfDescriptionShort(description_short_text ? description_short_text.length : 0)
            
            var tmp_variaty = [];
            var tmp_aroma = [];
            var tmp_allergy = [];
            var tmp_food = [];
            var tmp_aroma_taste = [];
            var tmp_vessel = [];
            var tmp_soil = [];
            var tmp_palate = [];
            if (grape_variety?.length > 0) {
                grape_variety.map((data, index) => {
                    tmp_variaty[index] = { grape: { value: data.grape._id, label: data.grape[`${globalState.language}`] }, percentage: data?.percentage }
                })
            }
            if (aroma?.length > 0) {
                aroma.map((data, index) => {
                    tmp_aroma[index] = { value: data._id, label: data[`${globalState.language}`] }
                })
            }
            if (food_pairing?.length > 0) {
                food_pairing.map((data, index) => {
                    tmp_food[index] = { value: data._id, label: data[`${globalState.language}`] }
                })
            }
            if (allergy?.length > 0) {
                allergy.map((data, index) => {
                    tmp_allergy[index] = { value: data._id, label: data[`${globalState.language}`] }
                })
            }
            if (aroma_taste?.length > 0) {
                aroma_taste.map((data, index) => {
                    tmp_aroma_taste[index] = { value: data._id, label: data[`${globalState.language}`] }
                })
            }
            if (soil_type?.length > 0) {
                soil_type.map((data, index) => {
                    tmp_soil[index] = { value: data._id, label: data[`${globalState.language}`] }
                })
            }
            if (vessel?.length > 0) {
                vessel.map((data, index) => {
                    tmp_vessel[index] = { value: data._id, label: data[`${globalState.language}`] }
                })
            }
            if (palate?.length > 0) {
                palate.map((data, index) => {
                    tmp_palate[index] = { value: data._id, label: data[`${globalState.language}`] }
                })
            }

            product_type._id === 0 && selectWineType({ value: product_type.sub[category - 1].index, label: product_type.sub[category - 1][`${globalState.language}`] }); // for taste

            setProductData({
                product_name: product_name,
                producer_name: producer.name,
                // for wine
                wine_color: wine_color ? { value: wine_color._id, label: wine_color[`${globalState.language}`] } : "",
                product_type: { value: product_type._id, label: product_type[`${globalState.language}`] },
                wine_type: product_type._id === 0 ? { value: product_type.sub[category - 1].index, label: product_type.sub[category - 1][`${globalState.language}`] } : "",
                fortified_wine_type: product_type._id === 0 && sub_category >= 0 ? { value: sub_category, label: product_type.sub[category - 1].sub[sub_category] } : "",
                variaty: grape_variety ? tmp_variaty : "",
                barrel_type: barrel_type ? barrel_type : "",
                wine_acid: wine_acid ? wine_acid : "",
                // for spirit
                spirit_sub_type: product_type._id === 1 && sub_category >= 0 ? { value: sub_category, label: product_type.sub[category].sub[sub_category] } : "",
                spirit_type: product_type._id === 1 ? { value: product_type.sub[category].index, label: product_type.sub[category][`${globalState.language}`] } : "",
                //for beer
                beer_type: product_type._id === 2 ? { value: product_type.sub[category].index, label: product_type.sub[category][`${globalState.language}`] } : "",
                // for wine & spirit
                vintage: { value: vintage, label: vintage ? vintage : "N/A" },
                //for all
                bottle_size: bottle_size ? bottlesize_options[bottle_size._id] : "",
                article: article_nr ? article_nr : "", //article_nr,
                // for basic
                country: country ? { value: country._id, label: country.name[`${globalState.language}`] } : "",
                region: region ? { value: region._id, label: region.name[`${globalState.language}`] } : "",
                sub_region: sub_region ? { value: sub_region._id, label: sub_region.name[`${globalState.language}`] } : "",
                description: description_text ? description_text : "",
                description_teaser: description_teaser_text ? description_teaser_text : "",
                description_short: description_short_text ? description_short_text : "",
                // for advanced
                alc_vol: alc_vol ? alc_vol : "",
                aroma: aroma ? tmp_aroma : "",
                food: food_pairing ? tmp_food : "",
                allergy: allergy ? tmp_allergy : "",
                closure_type: closure_type ? { value: closure_type._id, label: closure_type[`${globalState.language}`] } : "",
                taste: taste >= 0 ? { value: taste, label: product_type.sub[category - 1].taste[taste] } : "",
                residual_sugar: residual_sugar ? residual_sugar : "",

                // new added
                ean: ean ? ean : "",
                official_classification: official_classification ? { value: official_classification._id, label: official_classification[`${globalState.language}`] } : "",
                special_classification: special_classification ? { value: special_classification._id, label: special_classification[`${globalState.language}`] } : "",
                destillation: distillation ? { value: distillation._id, label: distillation[`${globalState.language}`] } : "",
                aromataste: aroma_taste ? tmp_aroma_taste : "",
                vessel: vessel ? tmp_vessel : "",
                palate: palate ? tmp_palate : "",
                soil: soil_type ? tmp_soil : "",
                acidity: acidity ? acidity : "",
                glassware: glassware ? { value: glassware._id, label: glassware[`${globalState.language}`] } : "",
                bottle_shape: bottle_shape ? { value: bottle_shape._id, label: bottle_shape[`${globalState.language}`] } : "",
                recomended_drinking_temperature: recomended_drinking_temperature ? [recomended_drinking_temperature[0], recomended_drinking_temperature[1]] : [-3,23]
            });

            bottle_image ? setBottleImages(`/public/${bottle_image.changed_name}`) : setBottleImages(null);
            bottle_image ? setShowBottleImages(`/public/${bottle_image.changed_name}`) : setShowBottleImages(null);
            setModalShow(true);

            dispatch(getAllRegion(country._id));
            dispatch(getAllSubRegion(country._id,region._id));

            // official_classification
            let official_cnt = 0;
            if (official_classifications?.length > 0) {
                official_classifications.map((data, index) => {
                    if(data.country == country._id){
                        official_classification_options[official_cnt] = { value: data._id, label: data[`${globalState.language}`] + " (" + data.shortcut + ")" }
                        official_cnt++;
                    }
                    setOfficialClassificationOption([...official_classification_options]);
                })
            }

            // special_classification
            let special_cnt = 0;
            if (special_classifications?.length > 0) {
                special_classifications.map((data, index) => {
                    if(data.country == country._id){
                        special_classification_options[special_cnt] = { value: data._id, label: data[`${globalState.language}`]}
                        special_cnt++;
                    }
                    setSpecialClassificationOption([...special_classification_options]);
                })
            }
        } else {
            dispatch(openSnackBar({ status: "error", message: t("msg_select_product_create") }));
        }


    }

    const setBottle = (data) => {
        changeState["bottle_image"] = "change";

        setChangeState({ ...changeState });
        setBottleImages(data);
    }
    const closeModal = () => {
        swal.fire({
            title: t("swal_are_you_sure"),
            text: t("swal_leave_page"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("swal_leave")
        })
            .then(result => {
                if (result.isConfirmed) {
                    close();
                }
            });

    }

    function close() {
        setModalShow(false);
        setOverStyle(false);
        setBottleImages(null);
        setShowBottleImages(null);
        setGrape("");
        setPercentage("");
        // setProductType("");
        setCurrentLengthOfDescription(0);
        setCurrentLengthOfDescriptionTeaser(0);
        setCurrentLengthOfDescriptionShort(0);
    }

    // const { producer } = props;
    const { variaty } = productData;

    return (
        <>
            <div onClick={() => openModal()} className="font-medium text-sm text-slate-600 hover:text-blue-500 flex py-1 px-3 cursor-pointer hover:bg-gray-100">
                {/* <FaRegEdit className="h-5 w-5 ml-1 mr-2
                " /> */}
                <svg className="h-5 w-5 ml-1 mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="M12.667,14.136l-3.712.531.53-3.713,9.546-9.546A2.25,2.25,0,0,1,22.213,4.59Z" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.122,14.25v7.5a1.5,1.5,0,0,1-1.5,1.5h-15a1.5,1.5,0,0,1-1.5-1.5v-15a1.5,1.5,0,0,1,1.5-1.5h7.5" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <>{t("edit")}</>
                
            </div>
            <Modal
                show={modalShow}
                size="xl"
                popup={true}
                onClose={() => closeModal()}
            >
                <Modal.Header className="py-4 px-6 ">
                    {t("edit_product")}
                </Modal.Header>
                <hr />
                <Modal.Body className="overflow-y-auto !py-0" style={{ maxHeight: "70vh" }}>
                    {/* producer */}
                    <div>
                        <div className="m-2 ml-2 text-sm block">
                            {t("producer")}
                        </div>
                        {/* <TextInput
                            id="searchproducer"
                            type="text"
                            placeholder="Producer Name"
                            required={true}
                            value={productData.producer_name}
                            disabled
                        /> */}
                        <input id="searchproducer"
                            type="text"
                            placeholder={t("producer_name")}
                            required={true}
                            value={productData.producer_name}
                            disabled
                            className="form-input w-full border-gray-300" style={{ borderRadius: '4px' }} />
                    </div>

                    {
                        // for all
                        productData.product_type.value >= 0 &&
                        <div>
                            {/* product name */}
                            <div>
                                <div className="m-2 ml-2 text-sm block">
                                    {t("product_name")}<span className='text-red-700'>*</span>
                                </div>
                                {/* <TextInput
                                    type="text"
                                    onChange={e => handleInputChange("product_name", e.target.value)}
                                    // placeholder="Producer Name"
                                    value={productData.product_name}
                                /> */}
                                <input id="default" type="text"
                                    onChange={e => handleInputChange("product_name", e.target.value)}
                                    // placeholder="Producer Name"
                                    value={productData.product_name}
                                    // disabled={props.condition.role == 0 ? false : true }
                                    className="form-input w-full border-gray-300" style={{ borderRadius: '4px' }} />
                            </div>

                            {/* article nr */}
                            {
                                // globalState.condition.isGlobal !== "global" &&
                                <div>
                                    <div className="m-2 ml-2 text-sm block">
                                        {t("article_nr")}
                                    </div>
                                    <TextInput
                                        id="article"
                                        type="text"
                                        onChange={e => handleInputChange("article", e.target.value)}
                                        // placeholder="Producer Name"
                                        addon="#"
                                        value={productData.article}
                                    />
                                </div>
                            }

                            {/* {t("ean")} */}
                            <div>
                                <div className="m-2 ml-2 text-sm block">
                                    {t("ean")}
                                </div>
                                <input id="default" type="text"
                                    onChange={e => handleInputChange("ean", e.target.value)}
                                    // placeholder="Producer Name"
                                    value={productData.ean}
                                    className="form-input w-full border-gray-300" style={{ borderRadius: '4px' }} />
                            </div>
                        </div>

                    }

                    {/* product type */}
                    <div className={`${overStyle ? "pb-40" : "pb-4"}`}>
                        <div className="m-2 ml-2 text-sm block">
                            {t("product_type")}<span className='text-red-700'>*</span>
                        </div>
                        <div onClick={() => !productData.product_type && setOverStyle(!overStyle)}>
                            <SelectCustomStyle>
                                <Select
                                    value={productData.product_type}
                                    onChange={value => handleInputChange("product_type", value)}
                                    options={category_options}
                                    isDisabled={props.condition.role == 0 ? false : true}
                                />
                            </SelectCustomStyle>
                        </div>
                    </div>

                    {
                        productData.product_type.value >= 0 &&
                        <Accordion alwaysOpen={true} flush={true}>
                            <Accordion.Panel>
                                {/* Basic information */}
                                <Accordion.Title>
                                    {t("basic_info")}
                                </Accordion.Title>
                                <Accordion.Content>
                                    {/* vintage */}
                                    {
                                        // for wine & spirit
                                        productData.product_type.value < 2 &&
                                        <div>
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("vintage")}
                                            </div>
                                            <SelectCustomStyle>
                                                <Select
                                                    value={productData.vintage}
                                                    onChange={value => handleInputChange("vintage", value)}
                                                    options={vintage_options}
                                                    isSearchable
                                                />
                                            </SelectCustomStyle>
                                        </div>
                                    }

                                    {/* bottle size */}
                                    <div>
                                        <div className="m-2 ml-2 text-sm block">
                                            {t("bottle_size")}<span className='text-red-700'>*</span>
                                        </div>
                                        <SelectCustomStyle>
                                            <Select
                                                value={productData.bottle_size}
                                                onChange={value => handleInputChange("bottle_size", value)}
                                                options={bottlesize_options}
                                            />
                                        </SelectCustomStyle>
                                    </div>

                                    {/* alcohol */}
                                     <div>
                                        <div className="m-2 ml-2 text-sm block">
                                            {t("alc_vol")}
                                        </div>
                                        <TextInput
                                            type="text"
                                            onChange={e => handleInputChange("alc_vol", e.target.value)}
                                            addon="%/vol"
                                            value={productData.alc_vol}
                                        />
                                    </div>

                                    {/* country */}
                                    <div>
                                        <div className="m-2 ml-2 text-sm block">
                                            {t("country")}<span className='text-red-700'>*</span>
                                        </div>
                                        <SelectCustomStyle>
                                            <Select
                                                value={productData.country}
                                                onChange={value => { handleInputChange("country", value); selectCountry(value); }}
                                                options={country_options}
                                                isSearchable
                                                isDisabled={props.condition.role == 0 ? false : true}
                                            />
                                        </SelectCustomStyle>
                                    </div>

                                    {/* region */}
                                    <div>
                                        <div className="m-2 ml-2 text-sm block">
                                            {t("region")}<span className='text-red-700'>*</span>
                                        </div>
                                        <SelectCustomStyle>
                                            <Select
                                                value={productData.region}
                                                onChange={value => { handleInputChange("region", value); selectRegion(value); }}
                                                options={region_options}
                                                isDisabled={props.condition.role == 0 ? false : true}
                                                // isDisabled={props.condition.role == 0 && showRegionSelect && region_options.length > 0 ? false : true}
                                                // isDisabled
                                                isSearchable
                                            />
                                        </SelectCustomStyle>
                                    </div>

                                    {/* sub region */}
                                    {
                                        // for wine
                                        productData.product_type.value == 0 &&
                                        <div>
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("sub_region")}
                                            </div>
                                            <SelectCustomStyle>
                                                <Select
                                                    value={productData.sub_region}
                                                    onChange={value => handleInputChange("sub_region", value)}
                                                    options={subregion_options}
                                                    isSearchable
                                                    isDisabled={props.condition.role == 0 ? false : true}
                                                    // isDisabled={props.condition.role == 0 && showSubRegionSelect && subregion_options.length > 0 ? false : true}
                                                    // isDisabled
                                                />
                                            </SelectCustomStyle>
                                        </div>
                                    }

                                    {/* teaser description */}
                                    <div>
                                        <div className="m-2 ml-2 block">
                                            {t("description_teaser")}
                                        </div>
                                        <Textarea
                                            id="searchproducer"
                                            type="text"
                                            placeholder={t("description_teaser")}
                                            rows={2}
                                            value={productData.description_teaser}
                                            onChange={(e) => { handleInputChange("description_teaser", e.target.value); setCurrentLengthOfDescriptionTeaser(e.target.value.length) }}
                                        />
                                        <div className={`mt-2 ml-2 text-sm flex justify-between ${currentLengthOfDescriptionTeaser > 1000 ? "text-red-600" : "text-sitetx-100"}`}>
                                            <div>max. 100 {t("characters")}</div>
                                            <div>{currentLengthOfDescriptionTeaser}/100</div>
                                        </div>
                                    </div>

                                    {/* description */}
                                    <div>
                                        <div className="m-2 ml-2 block">
                                            {t("description")}
                                        </div>
                                        <Textarea
                                            id="searchproducer"
                                            type="text"
                                            placeholder={t("description")}
                                            rows={8}
                                            value={productData.description}
                                            onChange={(e) => { handleInputChange("description", e.target.value); setCurrentLengthOfDescription(e.target.value.length) }}
                                        />
                                        <div className={`mt-2 ml-2 text-sm flex justify-between ${currentLengthOfDescription > 1000 ? "text-red-600" : "text-sitetx-100"}`}>
                                            <div>max. 500 {t("characters")}</div>
                                            <div>{currentLengthOfDescription}/500</div>
                                        </div>
                                    </div>

                                    {/* Short description */}
                                    <div>
                                        <div className="m-2 ml-2 block">
                                            {t("description_short")}
                                        </div>
                                        <Textarea
                                            id="searchproducer"
                                            type="text"
                                            placeholder={t("description_short")}
                                            rows={4}
                                            value={productData.description_short}
                                            onChange={(e) => { handleInputChange("description_short", e.target.value); setCurrentLengthOfDescriptionShort(e.target.value.length) }}
                                        />
                                        <div className={`mt-2 ml-2 text-sm flex justify-between ${currentLengthOfDescriptionShort > 1000 ? "text-red-600" : "text-sitetx-100"}`}>
                                            <div>max. 250 {t("characters")}</div>
                                            <div>{currentLengthOfDescriptionShort}/250</div>
                                        </div>
                                    </div>
                                    
                                    {/* bottle image */}
                                    <UploadImage
                                        title={t("bottle_image")}
                                        setImage={setBottleImages}
                                        showImage={showBottleImage}
                                        setShowImage={setShowBottleImages}
                                    />

                                    {/* allergy */}
                                    <MultiData
                                        title={t("allergenes")}
                                        itemTitle="allergy"
                                        option_data={allergy_options}
                                        exist_data={productData.allergy}
                                        setExistData={setExistData}
                                        addMultiData={addMultiData}
                                        setChangeData={setChangedData}
                                    />
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title>
                                    {productData.product_type.label.toUpperCase()} {t("info_upper")}
                                </Accordion.Title>
                                <Accordion.Content>
                                    {
                                        // wine
                                        productData.product_type.value == 0 && 
                                        <div>
                                            {/* wine color */}
                                            <div>
                                                <div className="m-2 ml-2 text-sm block">
                                                    {t("wine_color")}<span className='text-red-700'>*</span>
                                                </div>
                                                <SelectCustomStyle>
                                                    <Select
                                                        value={productData.wine_color}
                                                        onChange={value => handleInputChange("wine_color", value)}
                                                        options={winecolor_options}
                                                        isDisabled={props.condition.role == 0 ? false : true}
                                                    />
                                                </SelectCustomStyle>
                                            </div>

                                            {/* wine type */}
                                            <div>
                                                <div className="m-2 ml-2 text-sm block">
                                                    {t("wine_type")}<span className='text-red-700'>*</span>
                                                </div>
                                                <SelectCustomStyle>
                                                    <Select
                                                        value={productData.wine_type}
                                                        onChange={value => selectWineType(value)}
                                                        options={winetype_options}
                                                        isDisabled={props.condition.role == 0 ? false : true}
                                                    />
                                                </SelectCustomStyle>
                                            </div>

                                            {/* fortified type */}
                                            <div>
                                                <div className="m-2 ml-2 text-sm block">
                                                    {t("fortified_wine_type")}
                                                </div>
                                                <SelectCustomStyle>
                                                    <Select
                                                        value={productData.fortified_wine_type}
                                                        onChange={value => handleInputChange("fortified_wine_type", value)}
                                                        options={fortified_options}
                                                        isDisabled={props.condition.role == 0 ? false : true}
                                                        isSearchable
                                                    />
                                                </SelectCustomStyle>
                                            </div>

                                            {/* official classification */}
                                            <div>
                                                <div className="m-2 ml-2 text-sm block">
                                                    {t("official_classification")}
                                                </div>
                                                <SelectCustomStyle>
                                                    <Select
                                                        value={productData.official_classification}
                                                        onChange={value => handleInputChange("official_classification", value)}
                                                        options={official_classification_options}
                                                        isSearchable
                                                    />
                                                </SelectCustomStyle>
                                            </div>

                                            {/* special classification */}
                                            <div>
                                                <div className="m-2 ml-2 text-sm block">
                                                    {t("special_classification")}
                                                </div>
                                                <SelectCustomStyle>
                                                    <Select
                                                        value={productData.special_classification}
                                                        onChange={value => handleInputChange("special_classification", value)}
                                                        options={special_classification_options}
                                                        isSearchable
                                                    />
                                                </SelectCustomStyle>
                                            </div>

                                            {/* grape variety */}
                                            <div>
                                                <div className="m-2 ml-2 py-2 text-sm block">
                                                    {t("grape_varieties")}
                                                </div>
                                                <div className="grid gap-4 align-middle pb-2" style={{ gridTemplateColumns: "2fr 1.5fr 0.5fr" }}>
                                                    <div className="m-2 ml-2 text-sm block">{t("variety")}</div>
                                                    <div className="m-2 ml-2 text-sm block">{t("percentage")}</div>
                                                    <div className="m-2 ml-2 text-sm block"></div>
                                                </div>
                                            </div>

                                            {
                                                // for added grape
                                                variaty.map((data, index) =>
                                                    <div key={index} className="grid gap-4 align-middle pb-2" style={{ gridTemplateColumns: "2fr 1.5fr 0.5fr" }}>
                                                        <div>
                                                            <SelectGrapeStyle>
                                                                <Select
                                                                    value={data.grape}
                                                                    onChange={value => setExistVariate("grape", index, value)}
                                                                    options={grape_options}
                                                                    isSearchable
                                                                />
                                                            </SelectGrapeStyle>
                                                        </div>
                                                        <div>
                                                            <TextInput
                                                                id="percentage"
                                                                type="number"
                                                                max={100}
                                                                min={0}
                                                                onChange={e => setExistVariate("percentage", index, e.target.value)}
                                                                // placeholder="Producer Name"
                                                                addon="%"
                                                                value={data?.percentage}
                                                            />
                                                        </div>
                                                        <div>
                                                            <label onClick={() => setExistVariate("remove", index)} className="flex flex-col justify-center items-center float-right w-10 h-10 bg-red-100 rounded-lg border-2 border-red-500 cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-red-200 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                                                                <div className="flex flex-col justify-center items-center pt-5 pb-6">
                                                                    <HiOutlineMinus className="text-red-500 h-6 w-6" />
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            
                                            {/* for add grape */}
                                            <div>
                                                <div className="grid gap-4 align-middle" style={{ gridTemplateColumns: "2fr 1.5fr 0.5fr" }}>
                                                    <div>
                                                        <SelectGrapeStyle>
                                                            <Select
                                                                value={grape}
                                                                onChange={value => setAddVariate("grape", value) }
                                                                options={grape_options}
                                                                isSearchable
                                                            />
                                                        </SelectGrapeStyle>
                                                    </div>
                                                    <div>
                                                        <TextInput
                                                            id="percentage"
                                                            type="number"
                                                            max={100}
                                                            min={0}
                                                            onChange={e => setAddVariate("percentage", e.target.value)}
                                                            // placeholder="Producer Name"
                                                            addon="%"
                                                            value={percentage}
                                                        />
                                                    </div>
                                                    <div>
                                                        <label onClick={() => removeGrapeVariaty()} className="flex flex-col justify-center items-center float-right w-10 h-10 bg-red-100 rounded-lg border-2 border-red-500 cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-red-200 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                                                            <div className="flex flex-col justify-center items-center pt-5 pb-6">
                                                                <HiOutlineMinus className="text-red-500 h-6 w-6" />
                                                            </div>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div onClick={() => addGrapeVariaty()} className="flex justify-center items-center w-full pt-2">
                                                    <label className="flex flex-col justify-center items-center w-full h-14 bg-gray-50 rounded-lg border-2 border-sitebg-50 cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                                                        <div className="flex flex-col justify-center items-center pt-5 pb-6">
                                                            <HiOutlinePlus className="ml-2 h-7 w-7 text-sitebg-50" />
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>

                                            {/* residual sugar taste */}
                                            <div>
                                                <div className="m-2 ml-2 text-sm block">
                                                    {t("taste_residual_sugar")}
                                                </div>
                                                <SelectCustomStyle>
                                                    <Select
                                                        value={productData.taste}
                                                        onChange={value => handleInputChange("taste", value)}
                                                        options={taste_options}
                                                    />
                                                </SelectCustomStyle>
                                            </div>
                                        </div>
                                    }
                                    {
                                        // spirit
                                        productData.product_type.value == 1 && 
                                        <div>
                                            {/* spirit type */}
                                            <div>
                                                <div className="m-2 ml-2 text-sm block">
                                                    {t("spirit_type")}<span className='text-red-700'>*</span>
                                                </div>
                                                <SelectCustomStyle>
                                                    <Select
                                                        value={productData.spirit_type}
                                                        onChange={value => selectSpiritType(value)}
                                                        options={spirittype_options}
                                                        isSearchable
                                                        isDisabled={props.condition.role == 0 ? false : true}
                                                    />
                                                </SelectCustomStyle>
                                            </div>

                                            {/* spirit sub type */}
                                            <div>
                                                <div className="m-2 ml-2 text-sm block">
                                                    {t("spirit_sub_type")}
                                                </div>
                                                <SelectCustomStyle>
                                                    <Select
                                                        value={productData.spirit_sub_type}
                                                        onChange={value => handleInputChange("spirit_sub_type", value)}
                                                        options={spiritsubtype_options}
                                                        isSearchable
                                                        isDisabled={props.condition.role == 0 ? false : true}
                                                    />
                                                </SelectCustomStyle>
                                            </div>

                                            {/* destillation method */}
                                            <div>
                                                <div className="m-2 ml-2 text-sm block">
                                                    {t("destillation_method")}
                                                </div>
                                                <SelectCustomStyle>
                                                    <Select
                                                        value={productData.destillation}
                                                        onChange={value => handleInputChange("destillation", value)}
                                                        options={destillation_options}
                                                        isSearchable
                                                    />
                                                </SelectCustomStyle>
                                            </div>
                                        </div>
                                    }
                                    {
                                        // beer
                                        productData.product_type.value == 2 && 
                                        <div>
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("beer_type")}<span className='text-red-700'>*</span>
                                            </div>
                                            <SelectCustomStyle>
                                                <Select
                                                    value={productData.beer_type}
                                                    onChange={value => handleInputChange("beer_type", value)}
                                                    options={beertype_options}
                                                    isDisabled={props.condition.role == 0 ? false : true}
                                                />
                                            </SelectCustomStyle>
                                        </div>
                                    }
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title>
                                    {t("sensorics_cultivation")}
                                </Accordion.Title>
                                <Accordion.Content>
                                    {/* aroma */}
                                    <MultiData
                                        title={t("aroma")}
                                        itemTitle="aroma"
                                        option_data={aroma_options}
                                        exist_data={productData.aroma}
                                        setExistData={setExistData}
                                        addMultiData={addMultiData}
                                        setChangeData={setChangedData}
                                    />

                                    {/* aroma taste */}
                                    <MultiData
                                        title={t("taste")}
                                        itemTitle="aromataste"
                                        option_data={aroma_options}
                                        exist_data={productData.aromataste}
                                        setExistData={setExistData}
                                        addMultiData={addMultiData}
                                        setChangeData={setChangedData}
                                    />

                                    {/* palate */}
                                    {
                                        // for wine
                                        productData.product_type.value == 0 &&
                                        <MultiData
                                            title={t("palate")}
                                            itemTitle="palate"
                                            option_data={palate_options}
                                            exist_data={productData.palate}
                                            setExistData={setExistData}
                                            addMultiData={addMultiData}
                                            setChangeData={setChangedData}
                                        />
                                    }

                                    {/* food pairing */}
                                    <MultiData
                                        title={t("food_pairing")}
                                        itemTitle="food"
                                        option_data={food_options}
                                        exist_data={productData.food}
                                        setExistData={setExistData}
                                        addMultiData={addMultiData}
                                        setChangeData={setChangedData}
                                    />

                                    {/* vessel */}
                                    <MultiData
                                        title={t("vermentation_vessels")}
                                        itemTitle="vessel"
                                        option_data={vessel_options}
                                        exist_data={productData.vessel}
                                        setExistData={setExistData}
                                        addMultiData={addMultiData}
                                        setChangeData={setChangedData}
                                    />

                                    <div>
                                        <div className="m-2 ml-2 text-sm block">
                                            {t("barrel_type")}
                                        </div>
                                        <TextInput
                                            type="text"
                                            onChange={e => handleInputChange("barrel_type", e.target.value)}
                                            // placeholder="Producer Name"
                                            value={productData.barrel_type}
                                        />
                                    </div>
                                    
                                    {/* soil type */}
                                    {
                                        // for wine
                                        productData.product_type.value == 0 &&
                                        <MultiData
                                            title={t("soil_type")}
                                            itemTitle="soil"
                                            option_data={soil_options}
                                            exist_data={productData.soil}
                                            setExistData={setExistData}
                                            addMultiData={addMultiData}
                                            setChangeData={setChangedData}
                                        />
                                    }
                                </Accordion.Content>
                            </Accordion.Panel>
                            <Accordion.Panel>
                                <Accordion.Title>
                                    {t("analytics_other_info")}
                                </Accordion.Title>
                                <Accordion.Content>
                                    <div>
                                        {/* residual sugar */}
                                        <div>
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("taste_residual_sugar")}
                                            </div>
                                            <TextInput
                                                type="text"
                                                onChange={e => handleInputChange("residual_sugar", e.target.value)}
                                                // placeholder="Producer Name"
                                                value={productData.residual_sugar}
                                                addon="g/l"
                                            />
                                        </div>

                                        {/* acidity */}
                                        <div>
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("acidity")}
                                            </div>
                                            <TextInput
                                                type="text"
                                                onChange={e => handleInputChange("acidity", e.target.value)}
                                                // placeholder="Producer Name"
                                                value={productData.acidity}
                                                addon="g/l"
                                            />
                                        </div>

                                        {/* closure type */}
                                        <div>
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("closure_type")}
                                            </div>
                                            <SelectCustomStyle>
                                                <Select
                                                    value={productData.closure_type}
                                                    onChange={value => handleInputChange("closure_type", value)}
                                                    options={closureType_options}
                                                    isSearchable
                                                />
                                            </SelectCustomStyle>
                                        </div>

                                        {/* glassware */}
                                        <div>
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("glassware")}
                                            </div>
                                            <SelectCustomStyle>
                                                <Select
                                                    value={productData.glassware}
                                                    onChange={value => handleInputChange("glassware", value)}
                                                    options={glassware_options}
                                                    isSearchable
                                                />
                                            </SelectCustomStyle>
                                        </div>

                                        {/* bottle shape */}
                                        {
                                            // for wine
                                            productData.product_type.value == 0 &&
                                            <div>
                                                <div className="m-2 ml-2 text-sm block">
                                                    {t("bottle_shape")}
                                                </div>
                                                <SelectCustomStyle>
                                                    <Select
                                                        value={productData.bottle_shape}
                                                        onChange={value => handleInputChange("bottle_shape", value)}
                                                        options={bottle_shape_options}
                                                        isSearchable
                                                    />
                                                </SelectCustomStyle>
                                            </div>
                                        }

                                        {/* recomended_drinking_temperature */}
                                        <div className="py-4">
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("recomended_drinking_temperature")}
                                            </div>
                                            <MultiRange type="recomended_drinking_temperature" value={productData.recomended_drinking_temperature} setValue={handleInputChange} />
                                        </div>
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                        </Accordion>
                    }
                </Modal.Body>
                <hr />
                <Modal.Footer>
                    <div className="flex flex-wrap items-center gap-4 m-auto">
                        <div>
                            <Button onClick={() => closeModal()} color={'red'} className="bg-white bg-opacity-0 text-red-500 border-red-500 border-2">
                                {/* <HiOutlineTrash className="mr-2 h-5 w-5" /> */}
                                <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5">
                                    <path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M18.0576 22.3846H5.94219C5.48317 22.3846 5.04294 22.2023 4.71836 21.8777C4.39377 21.5531 4.21143 21.1129 4.21143 20.6538V5.07692H19.7883V20.6538C19.7883 21.1129 19.606 21.5531 19.2814 21.8777C18.9568 22.2023 18.5166 22.3846 18.0576 22.3846Z"/>
                                    <path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M9.40381 17.1923V10.2692"/>
                                    <path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M14.5962 17.1923V10.2692"/>
                                    <path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M0.75 5.07692H23.25"/>
                                    <path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M14.5962 1.61539H9.40386C8.94484 1.61539 8.50461 1.79774 8.18003 2.12232C7.85544 2.4469 7.6731 2.88713 7.6731 3.34616V5.07693H16.3269V3.34616C16.3269 2.88713 16.1446 2.4469 15.82 2.12232C15.4954 1.79774 15.0552 1.61539 14.5962 1.61539Z"/></svg>
                                {t("dismiss")}
                            </Button>
                        </div>
                        <div>
                            <Button onClick={() => saveProduct()} className="bg-sitebg-300">
                                {t("save_product")}
                                {/* <HiOutlineDocumentAdd className="ml-2 h-6 w-6" /> */}
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4"
                                    viewBox="0 0 24 24">
                                    <path className="st0" d="M22.4,17.4l-5,5c-0.6,0.6-1.3,0.9-2.1,0.9H3.8c-1.7,0-3-1.3-3-3V3.8c0-1.7,1.3-3,3-3h16.5c1.7,0,3,1.3,3,3l0,0
                                        v11.5C23.3,16.1,22.9,16.8,22.4,17.4z"/>
                                    <path className="st0" d="M15.8,23.2v-4.5c0-1.7,1.3-3,3-3h4.5"/>
                                    <line className="st0" x1="12" y1="7.5" x2="12" y2="16.5"/>
                                    <line className="st0" x1="7.5" y1="12" x2="16.5" y2="12"/>
                                </svg>
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default CreateProduct;
